import { TransactionResource } from '@olxeu-a2b/core/typings';

declare type OrderStatus = TransactionResource['attributes']['status'];

export const EXTERNAL_LINKS = {
  PROTECTION_PACKAGE_INFO:
    'https://pomoc.olx.pl/hc/pl/articles/4404784585618-Co-to-jest-Pakiet-Ochronny-',
};

export const ORDER_STATUS: Record<OrderStatus, OrderStatus> = {
  ORDER_CREATED: 'ORDER_CREATED',
  ORDER_REJECTED: 'ORDER_REJECTED',
  ORDER_EXPIRED: 'ORDER_EXPIRED',
  CONTRACT_REQUESTED: 'CONTRACT_REQUESTED',
  CONTRACT_CREATED: 'CONTRACT_CREATED',
  SHIPMENT_LABEL_RECEIVED: 'SHIPMENT_LABEL_RECEIVED',
  PACKAGE_POSTED: 'PACKAGE_POSTED',
  PACKAGE_IN_TRANSIT: 'PACKAGE_IN_TRANSIT',
  PACKAGE_DELIVERED: 'PACKAGE_DELIVERED',
  PACKAGE_REJECTED: 'PACKAGE_REJECTED',
  PAYOUT_PENDING: 'PAYOUT_PENDING',
  PAYOUT_SENT: 'PAYOUT_SENT',
  CONTRACT_CANCELLED: 'CONTRACT_CANCELLED',
  SHIPMENT_ERROR: 'SHIPMENT_ERROR',
  KYC_VERIFICATION_PENDING: 'KYC_VERIFICATION_PENDING',
  SHIPMENT_EXPIRED: 'SHIPMENT_EXPIRED',
  REFUND_SENT: 'REFUND_SENT',
  PACKAGE_READY_TO_PICKUP: 'PACKAGE_READY_TO_PICKUP',
  CONTRACT_EXPIRED: 'CONTRACT_EXPIRED',
  KYC_RETRY_NEEDED_CONFIRMATION: 'KYC_RETRY_NEEDED_CONFIRMATION',
  KYC_RETRY_NEEDED_PAYOUT: 'KYC_RETRY_NEEDED_PAYOUT',
  PACKAGE_PICKUP_EXPIRED: 'PACKAGE_PICKUP_EXPIRED',
  PAYOUT_FAILED: 'PAYOUT_FAILED',
  REFUND_FAILED: 'REFUND_FAILED',
  REFUND_REQUESTED: 'REFUND_REQUESTED',
  PAYOUT_REQUESTED: 'PAYOUT_REQUESTED',
  DELIVERED_ITEM_REJECTED: 'DELIVERED_ITEM_REJECTED',
  SAFEDEAL_ACCEPTED_BY_BUYER: 'SAFEDEAL_ACCEPTED_BY_BUYER',
  SAFEDEAL_BUYER_ACCEPTANCE_EXPIRED: 'SAFEDEAL_BUYER_ACCEPTANCE_EXPIRED',
  SAFEDEAL_REJECTED_BY_BUYER: 'SAFEDEAL_REJECTED_BY_BUYER',
  SAFEDEAL_CS_PAYOUT_REQUESTED: 'SAFEDEAL_CS_PAYOUT_REQUESTED',
  SAFEDEAL_CS_FULL_REFUND_REQUESTED: 'SAFEDEAL_CS_FULL_REFUND_REQUESTED',
  SAFEDEAL_CS_DECISION_EXPIRED: 'SAFEDEAL_CS_DECISION_EXPIRED',
  SAFEDEAL_CS_RETURN_INITIATED: 'SAFEDEAL_CS_RETURN_INITIATED',
};

// these strings need to match values coming from BE.
export const DELIVERY_MODE = {
  BUY_WITH_DELIVERY: 'BuyWithDelivery',
  ASK_FOR_DELIVERY: 'Ask4Delivery',
  NOT_ELIGIBLE: 'NotEligible',
} as const;

export const A4D_TOOLTIP_TIMEOUT = 4000;

/* eslint-disable no-shadow */
export enum SAFE_DEAL_ACTION {
  ACCEPTANCE = 'accept',
  REJECTION = 'reject',
}

export enum SAFE_DEAL_ERROR_MESSAGE {
  MADE_PAYOUT = 'MADE_PAYOUT',
  WAITING_FOR_CS_ACTION = 'WAITING_FOR_CS_ACTION',
}

export const SAFE_DEAL_CLICK_SOURCE = {
  INFO_ICON_BUTTON: 'info_icon_button',
  LEARN_MORE: 'sd_learn_more_click',
  NULL: 'null',
};
/* eslint-enable no-shadow */

type KYC_STATUS_VALUE = 'KYC_REQUIRED' | 'KYC_NOT_NEEDED';
export const KYC_STATUS: Record<string, KYC_STATUS_VALUE> = {
  REQUIRED: 'KYC_REQUIRED',
  NOT_NEEDED: 'KYC_NOT_NEEDED',
};

export type Variants = 'a' | 'b' | 'c' | 'd';

export default {
  ORDER_STATUS,
  DELIVERY_MODE,
  A4D_TOOLTIP_TIMEOUT,
  SAFE_DEAL_ACTION,
  SAFE_DEAL_ERROR_MESSAGE,
  SAFE_DEAL_CLICK_SOURCE,
};
